import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '@frontend/components/pages/episodeCategory/customControls/customControlRegistry';
import { OsasLifeStyleFormRead } from './OsasLifeStyleFormRead';

CustomControlRegistry.instance.register({
    ReadElement: OsasLifeStyleFormRead,
    code: CustomControlCode.OSASLifestyleForm,
    version: 1,
});
